<template>
  <base-section id="novel-list">
    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <router-link :to="{ name: `${card.title}` }">
            <base-book-card v-bind="card" />
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionNovels',

    data: () => ({
      cards: [
        {
          title: 'Marianne',
          cover: require('@/assets/covers/marianne.png'),
          link: 'marianne'
        },
      ],
    }),
  }
</script>
